<template>
  <div id="app">
    <audio id="audio" loop="loop">
      <source src="./assets/bgmusic.mp3" type="audio/mp3">
    </audio>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted: function () {
    let clientWidth = document.documentElement.clientWidth || window.innerWidth;
    clientWidth = clientWidth > 750 ? 640 : clientWidth;
    var rem = clientWidth / 750 * 10;
    rem = rem.toFixed(2)
    document.querySelector('html').style.fontSize = rem + 'px';
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;

}
  html,body,#app {
    width: 100%;
    height: 100%;
    margin:0;
    padding:0;
  }
  #audio{
    width: 0;
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue